import axios from "axios";
import config from "../config";
import { projects } from "../config";
const baseUrl = "https://api-horcrux.flixstock.com";

const request = async ({
  method,
  params,
  url,
  body = null,
  transformRequest = null,
  transformResponse = null,
  timeout = 0,
  responseType = "json",
  onUploadProgress = null,
  onDownloadProgress = null,
}) => {
  const options = {
    baseURL: baseUrl,
    url: url,
    method: method,
    transformRequest: transformRequest,
    transformResponse: transformResponse,
    headers: {
      authorization: `Bearer ${localStorage.getItem("flowedit_token")}`,
      "Content-Type": "application/json",
      // "Access-Control-Allow-Origin": "*",
    },
    params: params,
    data: !!body && JSON.stringify(body),
    timeout: timeout,
    withCredentials: false,
    responseType: responseType,
    responseEncoding: "utf8",
    onUploadProgress: onUploadProgress,
    onDownloadProgress: onDownloadProgress,
    validateStatus: function (status) {
      return status >= 200 && status < 300; // default
    },
    maxRedirects: 5,
    decompress: true,
  };
  const { data, status, statusText, headers } = await axios.request(options);
  // Only parse JSON if responseType is "json" (default) and data is a string
  // For text/blob responses, return data as-is
  if (responseType === "json" && typeof data === "string") {
    try {
      return { data: JSON.parse(data), status, statusText, headers };
    } catch (e) {
      // If parsing fails, return the raw data
      return { data, status, statusText, headers };
    }
  }
  return { data, status, statusText, headers };
};

const GetRequest = async (options) => {
  const client = axios.create({
    baseURL: baseUrl,
    headers: { "x-auth-token": `${localStorage.getItem("token")}` },
    params: options.QueryParams,
  });
  return client.request(options);
};

const request2 = async (options) => {
  const client = axios.create({
    baseURL: baseUrl,
    headers: {
      "x-auth-token": `${localStorage.getItem("token")}`,
    },
  });
  return client.request(options);
};

const requestXlsxFileDownload = async (options) => {
  const client = axios.create({
    baseURL: baseUrl,
    headers: {
      authorization: `Bearer ${localStorage.getItem("flowedit_token")}`,
      "Access-Control-Expose-Headers": "Content-Disposition",
    },
    responseType: "blob",
  });
  return client.request(options);
};

const upload = async (header, options) => {
  const client = axios.create({ headers: header });
  return client.request(options);
};

const requests = {
  request,
  GetRequest,
  request2,
  requestXlsxFileDownload,
  upload,
};
export default requests;
